import { formatTime } from '@toasttab/buffet-pui-date-utilities'
import { track } from '@toasttab/do-secundo-analytics'

import {
  PROMO_BANNER_TYPES,
  PromoBanner,
  PromoBannerAvailability
} from '../@types'

// takes a time string of format 00:00 and returns a 12hr format with AM/PM
export const formatAvailabilityTime = (time: string) => {
  const [hourStr = '', minuteStr = ''] = time.split(':')
  const hours = Number(hourStr)
  const minutes = Number(minuteStr)
  const isPm = hours >= 12
  // trim minutes off if they are 00
  const showMinutes = minutes !== 0

  return formatTime({ hours, minutes, isPm }, showMinutes, 'en-US')
}

// takes a banner's availability and returns a summary string
export const getAvailabilitySummary = (
  availability: PromoBannerAvailability | null
) => {
  if (!availability || !availability.time) {
    return 'Available all day'
  }

  const { startTime, endTime } = availability.time
  const start = formatAvailabilityTime(startTime)
  const end = formatAvailabilityTime(endTime)

  return `Available ${start} - ${end}`
}

export const getPromoBannerMetrics = (banner: PromoBanner) => {
  const { bannerGuid, __typename: type } = banner

  const sharedMetrics = { bannerGuid, type }

  switch (type) {
    case PROMO_BANNER_TYPES.LoyaltyBanner:
      return sharedMetrics
    case PROMO_BANNER_TYPES.PromoCodeBanner:
    default:
      return { ...sharedMetrics, promoCode: banner.promoCode }
  }
}

type PromoBannerSessionData = {
  bannersSeen: Record<string, string>
  promoCodesSeen: Record<string, string>
}

export const trackPromoBannerSeen = (
  banner: PromoBanner,
  restaurantGuid: string
) => {
  const restaurantBannerSessionId = `promo-banners-${restaurantGuid}`

  let promoBannerSessionData: PromoBannerSessionData

  try {
    promoBannerSessionData = JSON.parse(
      window.sessionStorage.getItem(restaurantBannerSessionId) ||
        '{"bannersSeen":{},"promoCodesSeen":{}}'
    )
  } catch {
    promoBannerSessionData = { bannersSeen: {}, promoCodesSeen: {} }
  }

  const { bannerGuid } = banner
  const { bannersSeen = {}, promoCodesSeen = {} } = promoBannerSessionData

  if (bannersSeen[bannerGuid]) {
    return
  }

  track('Promo Banner - seen', getPromoBannerMetrics(banner))

  const isPromoCodeBanner = banner.__typename === 'PromoCodeBanner'

  try {
    window.sessionStorage.setItem(
      restaurantBannerSessionId,
      JSON.stringify({
        bannersSeen: { ...bannersSeen, [bannerGuid]: true },
        promoCodesSeen: {
          ...promoCodesSeen,
          ...(isPromoCodeBanner && { [banner.promoCode]: true })
        }
      })
    )
  } catch {}
}
